// extracted by mini-css-extract-plugin
export default {"ellipsisMultiLine":"typography_ellipsisMultiLine__rntIc"};